import { z } from 'zod';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE, uuidSchema } from './common.js';
import { emailSchema, passwordSchema, usernameSchema } from './auth.js';
export const USER_STATUSES = ['active', 'disabled'];
export const createUserSchema = z.object({
    email: emailSchema,
    username: usernameSchema.optional(),
    fullName: z.string().trim().min(1).max(200),
    password: passwordSchema,
    roleIds: z.array(uuidSchema).max(50).default([]),
    /** Only honoured for super administrators; others always create users in their own organization. */
    organizationId: uuidSchema.optional(),
});
export const updateUserSchema = z
    .object({
    fullName: z.string().trim().min(1).max(200),
    username: usernameSchema.nullable(),
    status: z.enum(USER_STATUSES),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, 'At least one field is required');
export const roleAssignmentSchema = z.object({
    roleId: uuidSchema,
    /** Limit the role to one school; omit/null for organization-wide. */
    schoolId: uuidSchema.nullable().default(null),
});
/** Provide ssignments (scoped) or the simpler
oleIds (all organization-wide). */
export const setUserRolesSchema = z
    .object({
    roleIds: z.array(uuidSchema).max(50).optional(),
    assignments: z.array(roleAssignmentSchema).max(100).optional(),
})
    .refine((v) => v.roleIds !== undefined || v.assignments !== undefined, 'roleIds or assignments is required');
export const listUsersQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    q: z.string().trim().max(100).optional(),
    status: z.enum(USER_STATUSES).optional(),
    organizationId: uuidSchema.optional(),
});
export const permissionCodeSchema = z.string().regex(/^[a-z_]+\.[a-z_]+$/);
export const createRoleSchema = z.object({
    name: z.string().trim().min(1).max(100),
    description: z.string().trim().max(500).default(''),
    permissions: z.array(permissionCodeSchema).max(500).default([]),
    organizationId: uuidSchema.optional(),
});
export const updateRoleSchema = z
    .object({
    name: z.string().trim().min(1).max(100),
    description: z.string().trim().max(500),
    permissions: z.array(permissionCodeSchema).max(500),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, 'At least one field is required');
export const listAuditQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    action: z.string().trim().max(100).optional(),
    entity: z.string().trim().max(100).optional(),
    userId: uuidSchema.optional(),
    organizationId: uuidSchema.optional(),
});
//# sourceMappingURL=users.js.map